import { ImageIcon } from "lucide-react";
import { Reveal, Overline } from "@/components/Motion";
import { COLLAGE } from "@/lib/assets";

const TILES = [
  { span: "md:col-span-7", ratio: "aspect-[16/10]" },
  { span: "md:col-span-5", ratio: "aspect-[16/10]" },
  { span: "md:col-span-4", ratio: "aspect-[4/5]" },
  { span: "md:col-span-4", ratio: "aspect-[4/5]" },
  { span: "md:col-span-4", ratio: "aspect-[4/5]" },
];

const Tile = ({ tile, img, index }) => (
  <Reveal delay={(index % 3) * 0.08} className={tile.span}>
    <div className={`relative ${tile.ratio} w-full overflow-hidden bg-evo-marble1 border border-white/8 group`}>
      {img ? (
        <>
          <img src={img} alt="EVO exhibition craftsmanship" style={{ objectPosition: "center 45%" }} className="w-full h-full object-cover transition-transform duration-[1.6s] ease-out group-hover:scale-105" />
          <div className="absolute inset-0 bg-evo-black/20" />
        </>
      ) : (
        <>
          <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-6">
            <ImageIcon size={28} className="text-evo-gold/40 mb-3" strokeWidth={1} />
            <p className="text-xs uppercase tracking-[0.25em] text-evo-ash/50">EVO Project</p>
            <p className="text-[10px] uppercase tracking-[0.2em] text-evo-ash/30 mt-2">Branding protected · awaiting photo</p>
          </div>
          <div className="absolute inset-0 opacity-[0.04]" style={{ backgroundImage: "repeating-linear-gradient(45deg, #C8A97E 0 1px, transparent 1px 14px)" }} />
        </>
      )}
    </div>
  </Reveal>
);

export const WhoWeAre = () => (
  <section data-testid="who-we-are" className="px-6 md:px-12 lg:px-20 py-28 md:py-36">
    <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-14">
      <div className="lg:col-span-4">
        <Reveal><Overline className="block mb-6">Who We Are</Overline></Reveal>
      </div>
      <div className="lg:col-span-8">
        <Reveal delay={0.1}>
          <h2 className="font-serif font-light text-3xl md:text-4xl lg:text-5xl leading-[1.15] tracking-tight text-evo-pearl text-balance">
            A global exhibition partner — <span className="text-evo-gold italic">Italian craftsmanship</span>, Middle East expertise, and a portfolio built on real projects delivered on the world's biggest show floors.
          </h2>
        </Reveal>
      </div>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-12 gap-5 md:gap-6">
      {TILES.map((tile, i) => <Tile key={i} tile={tile} img={COLLAGE[i]} index={i} />)}
    </div>
  </section>
);
